import axios from "axios";

export const webApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/web`, withCredentials: true });

export const errText = (e, fallback = "Something went wrong.") => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : fallback;
};

export const fmtBytes = (n) => {
  n = n || 0;
  if (n >= 1073741824) return `${(n / 1073741824).toFixed(1)} GB`;
  if (n >= 1048576) return `${(n / 1048576).toFixed(1)} MB`;
  return `${n ? Math.max(1, Math.round(n / 1024)) : 0} KB`;
};

export const fmtDate = (s) => {
  if (!s) return "-";
  const d = new Date(s);
  return isNaN(d) ? s.slice(0, 10) : d.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
};

export const fileUrl = (id, download) => `${process.env.REACT_APP_BACKEND_URL}/api/web/files/${id}/content${download ? "?download=1" : ""}`;
